import { render, staticRenderFns } from "./PerformanceCustomersList.vue?vue&type=template&id=48ede8ee&scoped=true&"
import script from "./PerformanceCustomersList.vue?vue&type=script&lang=ts&"
export * from "./PerformanceCustomersList.vue?vue&type=script&lang=ts&"
import style0 from "./PerformanceCustomersList.vue?vue&type=style&index=0&id=48ede8ee&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ede8ee",
  null
  
)

export default component.exports